import 'angular:locale/data:de';
import '@angular/compiler';
import 'zone.js';
import 'zone.js/testing';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "de";
